<template>
  <!-- CPAP 処方詳細 -->
  <div id="CpapInstrumentDetail">
    <div :id="getContainerType()">
      <div v-if="isEscrow" class="labelTitle lable">CPAP 処方詳細 預託処方変更</div>
      <div v-else class="labelTitle lable">CPAP 処方詳細</div>
      <div class="button-area"><b-button class="backButton is-primary" @click="back">戻る</b-button></div>
      <div id="item-contens">
        <cpapRequestDetail ref="detailEdit" :data="showDetailTargetData" :comment="true" :changeValue="true" :innerUser="!isHospital && !isDealer" :isUser="!isHospital && !isDealer" :temp="temp" :isEscrow="isEscrow" :circulation="false" :initialUseModule="changeBeforeData.useModule" :initialUseMoist="changeBeforeData.useMoist"/> <!--QA408_処方変更・再開時、加湿器有にすると設置日・加湿モード・加湿器設定が空白-->
        <div class="button-area">
          <b-button class="receptionistButton is-primary" @click="update">変更する</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import { cpapKindMap } from "@/components/mock/base/const.js";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetailEdit";

export default {
  name: "CpapInstrumentDetail",
  methods: {
    getContainerType: function(){
      let type = "container";
      if(this.isHospital || this.isDealer){
        type = "container-center"
      }
      return type;
    },
    back: function() {
      if(this.compleateFlg && this.backRoutParams) {this.backRoutParams.pdfDisplay = true;}
      if(this.backRoutName){
        this.$router.push({
          name: this.backRoutName,
          params: this.backRoutParams,
          isEscrow: this.$route.params["isEscrow"],
        });
      }else{
        this.$router.go(-1);
      }
    },
    start: function() {
      this.$router.push({ path: "/guest/cpap/CpapRequest" });
    },
    update: async function() {
      if(this.showDetailTargetData.existingFlag){
        var messsage = "処方変更を申込みます。<br/>内容を確認して「OK」ボタンを押してください。"
        this.$dialog.confirm({
          title: "申込み確認",
          message: messsage,
          cancelText: "修正する",
          onConfirm: async () => {
            this.compleateFlg = false;
            var excuteApi = this.setCpapChangePrescriptionRequestPOST;
            var successCallBack = this.setCpapChangePrescriptionRequestPOSTSuccess;
            var errorCallBack = this.setCpapChangePrescriptionRequestPOSTError;
            // WebAPI Call
            await this.apiCall(excuteApi, successCallBack, errorCallBack)
            if(this.compleateFlg){
              this.back()
            }
          } 
        });
        return
      }

      // QA476 バリデーション表示順修正
      var child = this.$refs.detailEdit;
      var errorMsg = "";
      this.showDetailTargetData.mode = child.getMode()

      /** 医療機関情報 必須チェック */
      var hospitalInfo = document.getElementsByClassName("hospitalInfo");
      var hospitalInfoResult = this.selfMadeValidation(hospitalInfo);
      errorMsg = errorMsg + hospitalInfoResult.msg;

      /** 患者情報 必須チェック */
      var patientInfo = document.getElementsByClassName("patientInfo");
      var patientInfoResult = this.selfMadeValidation(patientInfo);
      errorMsg = errorMsg + patientInfoResult.msg;

      // 電話番号は携帯か自宅のどちらかが必須
      var mobilePhone = document.getElementById("mobilePhone");
      var phoneNumber = document.getElementById("phoneNumber");
      mobilePhone.style["border-color"] = "";
      phoneNumber.style["border-color"] = "";
      if(!mobilePhone.value && !phoneNumber.value){
        errorMsg = errorMsg + "「連絡先（携帯電話）」「連絡（自宅・その他）」いずれかは必須項目です。\n"
        mobilePhone.style["border-color"] = "red";
        phoneNumber.style["border-color"] = "red";
      }

      /** 装置情報 必須チェック */
      var modelInfo = document.getElementsByClassName("modelInfo");
      var modelInfoResult = this.selfMadeValidation(modelInfo);
      errorMsg = errorMsg + modelInfoResult.msg;

      /** 設定情報 相関チェック */
      var model = this.modelList.find(item => item.reportFormatType == this.showDetailTargetData.reportFormatType)
      // if(!(this.isHospital || this.isDealer)){
        // if(this.showDetailTargetData.estimateDetailCode && this.showDetailTargetData.estimateDetailCode.length > 0){
          // let codes = model.itemCodes
          // let targets = this.showDetailTargetData.estimateDetailCode.filter(val => codes.indexOf(val.itemCode) != -1)
          // 暫定対応 機種を1種類ずつしか指定していないため「CPAP機器が複数選択されています。」のルートは通らない
          // let testData = ["RJPX500S16", "RJPX400S16", "RJPG500S16", "RJPX700S16", "R1152708", "R1151882"];
          // let targets = testData.filter(val => codes.indexOf(val) != -1)
          
          // let targets = this.showDetailTargetData.estimateDetailCode.filter(val => codes.indexOf(val.itemCode) != -1)
      //     if(targets.length < 1){
      //       this.showErrorMessage("CPAP機器が選択されていません。")
      //       return
      //       }
      //       if(targets.length > 1){
      //         this.showErrorMessage("CPAP機器が複数選択されています。")
      //         return
      //         }
      //     }
      // }

      // 相関チェック
      var errMsg = ""
      var correlationList = [];
      if (this.showDetailTargetData.mode) {
        switch(model.reportFormatType){
          case 1:
            // ドリームステーションAuto
            var lampStart = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
            if(this.showDetailTargetData.mode == "1"){
              var pressureMin = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              var pressureMax = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else{
              var pressureCpap = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                  });
                }
              }
            }
            break;
          case 2:
            // ドリームステーションPro
            var lampStart = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
            var pressureCpap = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
            if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
              if(Number(lampStart.value) > Number(pressureCpap.value)){
                // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                correlationList.push({
                  displayOrder: lampStart.displayOrder,
                  msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                });
              }
            }
            break;
          case 3:
            // ドリームステーションGo
            var lampStart = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
            if(this.showDetailTargetData.mode == "1"){
              var pressureMax = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              var pressureMin = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else{
              var pressureCpap = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                  });
                }
              }
            }
            break;
          case 4:
            // ドリームステーションBiPAP Auto
            var lampStart = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
            if(this.showDetailTargetData.mode == "4"){
              // CPAPモード
              var pressureCpap = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("CPAP圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else if(this.showDetailTargetData.mode == "8"){
              // Bi-Levelモード
              var epap = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "EPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              var ipap = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "IPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(epap.value) > Number(ipap.value)){
                  // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: epap.displayOrder,
                    msg: "「EPAP」に「IPAP」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(epap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「EPAP」以下の値を設定してください。\n",
                  });
                }
              }
              var flex = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if(flex.value=="1"){
                // 20251128_緊急対応
                // Bi-Flex
                // if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                //   if(Number(epap.value) == Number(ipap.value)){
                //     // 「IPAPの値≠EPAPの値」でない場合
                //     errMsg = errMsg + "「EPAP」「IPAP」に異なる値を設定してください。\n"
                //   }
                // }
              }else if(flex.value=="2" || flex.value=="3"){
                // C-Flex
                // C-Flex+
                if (errorMsg.indexOf("EPAP【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                  if(Number(epap.value) != Number(ipap.value)){
                    // 「IPAPの値=EPAPの値」でない場合
                    correlationList.push({
                      displayOrder: epap.displayOrder,
                      msg: "「EPAP」「IPAP」に同じ値を設定してください。\n",
                    });
                  }
                }
              }
            }else if(this.showDetailTargetData.mode == "1"){
              // Auto Bi-Levelモード
              var epapMin = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "EPAP最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              var ipapMax = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "IPAP最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("IPAP最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(epapMin.value) > Number(ipapMax.value)){
                  // "EPAP最小圧【hPa(cmH2O)】" <= "IPAP最大圧【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: epapMin.displayOrder,
                    msg: "「EPAP最小圧」に「IPAP最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              var psMin = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "PS最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              var psMax = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "PS最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(psMin.value) > Number(psMax.value)){
                  // "PS最小圧【hPa(cmH2O)】" <= "PS最大圧【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: psMin.displayOrder,
                    msg: "「PS最小圧」に「PS最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("PS最大圧【hPa(cmH2O)】】") == -1 && errorMsg.indexOf("IPAP最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                // QA474_処方値関連残
                if (child.bipapvaliFlag) {
                  // QA267_DS BiPAP AutoにおいてminEPAPとmaxIPAPの差分とPSの設定範囲の関係性が考慮できていない
                  if (Number(ipapMax.value) - Number(epapMin.value) < Number(psMax.value)) {
                    // "IPAP最大圧【hPa(cmH2O)"-"EPAP最小圧【hPa(cmH2O)】" >= "PS最大圧【hPa(cmH2O)】" で無い時
                    correlationList.push({
                      displayOrder: psMax.displayOrder,
                      msg: "「PS最大圧」に「IPAP最大圧」-「EPAP最小圧」以下の値を設定してください。\n",
                    });
                  }
                }
              }
              if (errorMsg.indexOf("EPAP最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("ランプスタート圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(epapMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプスタート圧」に「EPAP最小圧」以下の値を設定してください。\n",
                  });
                }
              }
              var flex = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if(flex.value=="1"){
                // 20251128_緊急対応
                // Bi-Flex
                // if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                //   if(Number(psMin.value)==0 && Number(psMax.value)==0){
                //     // 「PS最小圧≠0 または PS最大圧≠0 」でない場合
                //     errMsg = errMsg + "「PS最小圧」または「PS最大圧」に0以外の値を設定してください。\n"
                //   }
                // }
              }else if(flex.value=="2"){
                // C-Flex
                // if (errorMsg.indexOf("PS最小圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PS最大圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                //   if(Number(psMin.value)!=0 || Number(psMax.value)!=0){
                //     // 「PS最小圧=0」且つ「PS最大圧=0」でない場合
                //     errMsg = errMsg + "「PS最小圧」「PS最大圧」に0を設定してください。\n"
                //   }
                // }
              }
            }
            break;
          case 5:
            // エスボックス バイスタルク
            var lampStart = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "ランプ開始圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
            if(this.showDetailTargetData.mode == "4"){
              // CPAPモード
              // "ランプ開始圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
            }else if(this.showDetailTargetData.mode == "1"){
              // Auto CPAPモード
              var pressureMax = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              var pressureMin = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
              if (errorMsg.indexOf("ランプ開始圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプ開始圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: lampStart.displayOrder,
                    msg: "「ランプ開始圧」に「最小圧」以下の値を設定してください。\n",
                  });
                }
              }
            }
            break;
          case 6:
            // プリズマ ライン (prisma25S)
            if(this.showDetailTargetData.mode == "1"){
              // APAPモード
              var pressureMax = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              var pressureMin = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("最大圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("最小圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  correlationList.push({
                    displayOrder: pressureMin.displayOrder,
                    msg: "「最小圧」に「最大圧」以下の値を設定してください。\n",
                  });
                }
              }
            }else if(this.showDetailTargetData.mode == "7"){
              // Sモード
              var epap = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "EPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              var ipap = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "IPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("EPAP圧【hPa（cmH2O)】") == -1 && errorMsg.indexOf("IPAP圧【hPa（cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(epap.value) > Number(ipap.value)){
                  // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: epap.displayOrder,
                    msg: "「EPAP」に「IPAP」以下の値を設定してください。\n",
                  });
                }
              }
            }else if(this.showDetailTargetData.mode == "9"){
              // autoSモード
              var pdiffMin = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "PDIFF min 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              var pdiffMax = this.showDetailTargetData.prescriptionItems.find(val => val.displayName == "PDIFF max 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.showDetailTargetData.mode)) != -1))
              if (errorMsg.indexOf("PDIFF min 圧【hPa(cmH2O)】") == -1 && errorMsg.indexOf("PDIFF max 圧【hPa(cmH2O)】") == -1 ) { // QA427_一括表示対応（単項目チェックを通過した項目のみ項目間チェック）
                if(Number(pdiffMin.value) > Number(pdiffMax.value)){
                  // "PDIFF min 圧【hPa(cmH2O)】" <= "PDIFF max 圧【hPa(cmH2O)】" で無い時
                  correlationList.push({
                    displayOrder: pdiffMin.displayOrder,
                    msg: "「PDIFF min 圧」に「PDIFF max 圧」以下の値を設定してください。\n",
                  });
                }
              }
            }
            break;
        }
      }

      /** 加湿器、通信モジュール */
      const validateResult = await child.$validator.validateAll();
      // QA427_エラー内容を項目ごとに取得
      const errorList = child.$validator.errors.items;

      // 必須チェック結果をdisplayOrderとメッセージのみにする
      const sortList = errorList.map(val => {
        const match = val.field.match(/_(\d+)$/);
        let num = match ? Number(match[1]) : null;
        if (val.field.includes("form2")) {          // 本体
          num = num + 1;
        } else if (val.field.includes("form3_2")) { // モデム
          num = num + 200;
        } else if (val.field.includes("form3")) {   // 加湿器
          num = num + 100;
        }
        return {
          displayOrder: num,
          msg: val.msg + "。\n",
        };
      });

      var moistInfo = document.getElementsByClassName("moistInfo");
      var moistInfoResult = this.selfMadeValidation(moistInfo);
      if (moistInfoResult.isError) {
        sortList.push({
          displayOrder: 150,
          msg: moistInfoResult.msg,
        });
      }
      var moduleInfo = document.getElementsByClassName("moduleInfo");
      var moduleInfoResult = this.selfMadeValidation(moduleInfo);
      if (moduleInfoResult.isError) {
        sortList.push({
          displayOrder: 250,
          msg: moduleInfoResult.msg,
        });
      }

      // 必須チェックと相関チェックのエラーメッセージを統合してdisplayOrder順に並び替え
      sortList.push(...correlationList);
      sortList.sort((first, second) => first.displayOrder - second.displayOrder);

      // 表示するメッセージ変数に格納
      for (var i = 0; i < sortList.length; i++) {
        const error = sortList[i];
        errorMsg = errorMsg + error.msg;
      }

      /** マスク 必須チェック */
      if(!this.showDetailTargetData.maskItemCode || !this.showDetailTargetData.maskId){
        errorMsg = errorMsg + "「マスク」は必須項目です。\n"
      }

      if (!validateResult || errorMsg) {
        this.showErrorMessage(errorMsg)
        return
      }
　　　/***********************************************
 　　　見積紐づけ必須除外（内部ユーザー処方申込時）20231014
　　　************************************************/
      // if(!this.isHospital && !this.isDealer){
        // 内部ユーザーの場合、見積情報の整合性チェック
        // var moistList = []
        // var moduleList = []
      //   var errMsg = ""
      //   for(let item of this.cpapAccessories){
      //     switch(item.type){
      //       case "moist":
      //         moistList.push(item.itemCode)
      //         break;
      //       case "module":
      //         moduleList.push(item.itemCode)
      //         break;
      //     }
      //   }
      //   var cpapItem = this.showDetailTargetData.estimateDetailCode.find(item => item.itemCode == this.showDetailTargetData.model)
      //   var moistItem = this.showDetailTargetData.estimateDetailCode.find(item => moistList.indexOf(item.itemCode)!=-1)
      //   var moduleItem = this.showDetailTargetData.estimateDetailCode.find(item => moduleList.indexOf(item.itemCode)!=-1)
      //   if(!cpapItem){
      //     errMsg = "CPAP機器の品目に一致する見積明細番号が選択されていません。\n"
      //   }
      //   if(this.showDetailTargetData.useMoist && !moistItem){
      //     errMsg = errMsg + "加湿器の品目に一致する見積明細番号が選択されていません。\n"
      //   }
      //   if(!this.showDetailTargetData.useMoist && moistItem){
      //     errMsg = errMsg + "加湿器が有になっていません(見積番号選択済み)\n"
      //   }
      //   if(model.reportFormatType!=3 && model.reportFormatType!=5 && this.showDetailTargetData.useModule && !moduleItem){
      //     errMsg = errMsg + "通信モジュールの品目に一致する見積明細番号が選択されていません。\n"
      //   }
      //   if(model.reportFormatType!=3 && model.reportFormatType!=5 && !this.showDetailTargetData.useModule && moduleItem){
      //     errMsg = errMsg + "通信モジュールが有になっていません(見積番号選択済み)\n"
      //   }
      //   if(errMsg){
      //     this.showErrorMessage(errMsg)
      //     return
      //   }
      // }

      var messsage = "処方変更を申込みます。<br/>内容を確認して「OK」ボタンを押してください。"
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = false;
          var excuteApi = this.setCpapChangePrescriptionRequestPOST;
          var successCallBack = this.setCpapChangePrescriptionRequestPOSTSuccess;
          var errorCallBack = this.setCpapChangePrescriptionRequestPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg){
            this.back()
          }
        } 
      });
    },
    setCpapChangePrescriptionRequestPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.showDetailTargetData));
      if (!obj.mailNotification) {
        obj.hospitalMail = ""
      }
      // QA478　選択していないモードの設定値をデフォルトに変更する
      if (obj.prescriptionItems && obj.mode) {
        for (let setting of obj.prescriptionItems) {
          switch(setting.category) {
            case 0: // 本体
              if (setting.mode && !setting.mode.includes("0") && !setting.mode.includes(obj.mode)) {
                setting.value = setting.defaultValue
              }
              break;
            case 1: // 加湿器
            case 2: // モデム
              break;
          }
        }
      }
      let changedItems = []
      if(this.changeBeforeData){
        var modulChangeFlag = false;
        var moistAddFlag = false; //加湿器追加フラグ
        var modulAddFlag = false; //モデム追加フラグ
        if(obj.useModule && this.changeBeforeData.useModule){
          if(obj.moduleItemCode != this.changeBeforeData.moduleItemCode){
            // モデム有⇒有の場合かつモデムが変更されている場合
            modulChangeFlag = true;
          }
        }
        // 加湿器追加時（無⇒有）
        if(obj.useMoist && !(this.changeBeforeData.useMoist)){
          moistAddFlag = true;
        }
        // モデム追加時（無⇒有）
        if(obj.useModule && !(this.changeBeforeData.useModule)){
          modulAddFlag = true;
        }
        // 変更した項目(値)をチェック
        for(var item of this.changedCheckItems){
          // 患者情報の場合は、チェック項目の階層が異なる
          var beforeTarget = item.key == "patientArea" ? this.changeBeforeData.patient : this.changeBeforeData
          var target = item.key == "patientArea" ? obj.patient : obj
          // 初期値セット
          var checkValue = {areaName:item.key, isChange:false, items:[]}

          if(item.key == "prescriptionArea"){
            // 設定情報の場合、全項目を順に比較
            var moistAreaValue = {areaName:"moistArea", isChange:false, items:[], moistAdd:moistAddFlag}
            var moduleAreaValue = {areaName:"moduleArea", isChange:false, items:[], modulChange:modulChangeFlag, modulAdd:modulAddFlag, simultaneousExchange: false, oldModuleItemCode: "", saveSimultaneousExchange: false}
            // シリアル比較
            if(this.changeBeforeData.moistSerial != obj.moistSerial) {
              moistAreaValue.items.push({itemName:"moistSerial", before:this.changeBeforeData.moistSerial, after:obj.moistSerial})
              moistAreaValue.isChange = true
            }
            if(this.changeBeforeData.moduleSerial != obj.moduleSerial) {
              moduleAreaValue.items.push({itemName:"moduleSerial", before:this.changeBeforeData.moduleSerial, after:obj.moduleSerial})
              moduleAreaValue.isChange = true
            }
            if(this.changeBeforeData["reportFormatType"] != target.reportFormatType){// 機種変更
              if(this.orgUseModule && obj.useModule){// モデム有⇒有
                moduleAreaValue.simultaneousExchange = true;
                if((this.changeBeforeData["reportFormatType"] == "3") && (target.reportFormatType !="3")){
                  //Go⇒Go以外場合は同時交換対象外
                  moduleAreaValue.simultaneousExchange = false;
                }
                if((this.changeBeforeData["reportFormatType"] == "5") && (target.reportFormatType !="5")){
                  //エスボックス⇒エスボックス以外場合は同時交換対象外
                  moduleAreaValue.simultaneousExchange = false;
                }
                if((this.changeBeforeData["reportFormatType"] != "3") && (target.reportFormatType =="3")){
                  //Go以外⇒Goの場合は同時交換対象外
                  moduleAreaValue.simultaneousExchange = false;
                }
                if((this.changeBeforeData["reportFormatType"] != "5") && (target.reportFormatType =="5")){
                  //エスボックス以外⇒エスボックスの場合は同時交換対象外
                  moduleAreaValue.simultaneousExchange = false;
                }
              }
              if(moduleAreaValue.simultaneousExchange && obj.reportFormatType == "3"){
                moduleAreaValue.oldModuleItemCode = this.changeBeforeData.moduleItemCode;
              }
              // 機種変更している場合は、処方項目が異なる為比較不可
              checkValue.isChange = true
              moistAreaValue.isChange = true
              moduleAreaValue.isChange = true
              changedItems.push(checkValue)
              changedItems.push(moistAreaValue)
              changedItems.push(moduleAreaValue)
              continue
            }
            for(var prescription of target.prescriptionItems){
              let beforePrescription = this.changeBeforeData.prescriptionItems.find(v => v.displayOrder==prescription.displayOrder)
              if(beforePrescription && beforePrescription.value != prescription.value){
                switch(prescription.category){
                  case 0:
                    // 本体
                    checkValue.isChange = true
                    checkValue.items.push({itemName:prescription.displayName, before:beforePrescription.value, after:prescription.value, displayOrder:prescription.displayOrder})
                    break;
                  case 1:
                    // 加湿器
                    moistAreaValue.isChange = true
                    moistAreaValue.items.push({itemName:prescription.displayName, before:beforePrescription.value, after:prescription.value, displayOrder:prescription.displayOrder})
                    break;
                  case 2:
                    // 通信モジュール
                    moduleAreaValue.isChange = true
                    moduleAreaValue.items.push({itemName:prescription.displayName, before:beforePrescription.value, after:prescription.value, displayOrder:prescription.displayOrder})
                    break;
                }
              }
            }
            changedItems.push(checkValue)
            changedItems.push(moistAreaValue)
            changedItems.push(moduleAreaValue)
            continue
          }
          for(var val of item.value){
            if(beforeTarget[val] != target[val]) {
              checkValue.items.push({itemName:val, before:beforeTarget[val], after:target[val]})
              checkValue.isChange = true
            }
          }
          changedItems.push(checkValue)
        }
      }
      if(!this.temp){// 20240215 仮持出の場合obj.modelが書き換わっている為、初期化の必要なし
        if(this.formatType != obj.reportFormatType){
          obj.model = ""
        }
      }
      obj.temp = this.temp
      // 各パラメータの型変換
      obj.expectedReturnDate = obj.expectedReturnDate ? obj.expectedReturnDate.replace(/-/g, "/") : ""
      obj.transferDate = obj.transferDate ? obj.transferDate.replace(/-/g, "/") :""
      obj.instructionDate = obj.instructionDate ? obj.instructionDate.replace(/-/g, "/") :""
      obj.patient.age = obj.patient.age+""
      obj.patient.birthday = obj.patient.birthday ? obj.patient.birthday.replace(/-/g, "/") : ""
      obj.billingStartDate = obj.billingStartDate ? obj.billingStartDate.replace(/-/g, "/") : ""
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.appointedDeliveryDate = obj.appointedDeliveryDate ? obj.appointedDeliveryDate.replace(/-/g, "/") : ""
      obj.specifiedDeliveryDate = obj.specifiedDeliveryDate ? obj.specifiedDeliveryDate.replace(/-/g, "/") : ""
      obj.kind = this.cpapKindMap.applicationChange

      // 改行コード、タブを除去
      Object.keys(obj).forEach(key => {
        if (obj[key]) {
          obj[key] = this.replaceCharTab(obj[key]);
        }
      })
      Object.keys(obj.patient).forEach(key => {
        if (obj.patient[key]) {
          obj.patient[key] = this.replaceCharTab(obj.patient[key]);
        }
      })

      // 無の場合は、品目コード、シリアルを初期化(預託以外)
      if (!this.isEscrow) {
        obj.moistItemCode = !obj.useMoist ? "" : obj.moistItemCode
        obj.moistSerial = !obj.useMoist ? "" : obj.moistSerial
        obj.moduleItemCode = !obj.useModule ? "" : obj.moduleItemCode
        obj.moduleSerial = !obj.useModule ? "" : obj.moduleSerial
      }
      obj.changedItems = changedItems
      // 預託処方変更は預託機フラグをオンにする
      if (this.isEscrow) {
        obj.depositUseFlag = true;
      }
      return client.apis.externalCpap.setCpapChangePrescriptionRequestPOST({
        body:obj
      });
    },
    setCpapChangePrescriptionRequestPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.compleateFlg = true;
    },
    setCpapChangePrescriptionRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    replaceCharTab: function(inputChar) {
      if (typeof inputChar == 'string') {
        inputChar = inputChar.replace(/\t/g, '').replace(/(\r)*\n/g, '').replace(/\r/g, '');
      }
      return inputChar;
    },
  },
  data() {
    var backRoutName = this.$route.params["name"];
    var backRoutParams = this.$route.params;
    var showDetailTargetData = {}
    var formatType = ""
    var orgUseMoist,orgUseModule
    var changeBeforeData = null
    if(this.$route.params["selectedData"]){
      changeBeforeData = JSON.parse(JSON.stringify(this.$route.params["selectedData"]));
      showDetailTargetData = this.$route.params["selectedData"];
      showDetailTargetData.instructionDate = this.yyyy_hyp_MM_hyp_dd(new Date())
      orgUseMoist = showDetailTargetData.useMoist
      orgUseModule = showDetailTargetData.useModule
      formatType = showDetailTargetData.reportFormatType
    }
    // 仮持出申込み判定
    var temp = false;
    if(this.$route.params["temp"]){
      temp = this.$route.params["temp"];
    }
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var modelList = this.getCpapMaster();
    // 処方変更の際、変更した項目のチェック用定義
    var changedCheckItems = [
      {key:"basicArea", value:["instructionDate","contractEndDate","billingCurrentMonth","cancelReasonCode","depositContractEndDate","depositCancelReasonCode","depositBillingCurrentMonth","doctorName","clerkName","hospitalMail"]},
      {key:"patientArea", value:["patientRegistrationCard","patientFamilyName","patientFirstName","patientFamilyNameKana","patientFirstNameKana","gender","birthday","zip","address","address1","address2","receiverName","mobilePhone","phoneNumber","followUpCall","disease","infection","infectionName","hospitalName","doctorName"]},
      {key:"hardwareArea", value:["reportFormatType","serial","settingChanger"]},
      {key:"prescriptionArea", value:[]},
      // {key:"moistArea", value:[]},
      // {key:"moduleArea", value:[]},
      {key:"maskArea", value:["maskType","cushionSize","frameSize","fixingMethod","lot"]},
      {key:"orderArea", value:["billingStartDate","billComment","departmentCode","customerClass","directShippingType","leaseUpType","memo"]}
    ]
    var cpapAccessories = this.getCpapAccessoryList();
    const isEscrow = this.$route.params["isEscrow"]
    return {
      cpapKindMap:cpapKindMap,
      showDetailTargetData,
      backRoutName,
      backRoutParams,
      compleateFlg:false,
      role: role,
      extUserStatus: extUserStatus,
      isHospital,
      isDealer,
      orgUseMoist,
      orgUseModule,
      cpapAccessories,
      temp,
      modelList,
      changeBeforeData,
      changedCheckItems,
      formatType,
      isEscrow,
    };
  },
  filters: {},
  components: {
    cpapRequestDetail:CpapRequestDetail
  },
  async mounted() {
  }
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
a {
  text-decoration: underline;
}
.historyTable-area {
    max-height:500px;
    overflow-x: hidden;
    overflow-y: scroll;
}
.historyTable {
    width: 1150px !important;
}
.historyTable .date {
    width:120px !important;
}
.historyTable .operation {
    width:80px !important;
}
.historyTable .detail {
    width:500px !important;
}
.historyTable .operator{
    width:250px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapInstrumentDetail.vue